module.exports = __webpack_public_path__ + "img/wgk2.7c9d1d5b.png";